import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';

const TableRow50 = ({ title, value }) => {
  const intl = useIntl();
  return (
    <>
      <td
        colSpan="3"
        style={{
          backgroundColor: '#e6e6e6',
          textAlign: 'left',
          width: '25%',
          fontWeigth: 'bold',
        }}
      >
        <label style={{ fontSize: '17px' }}>{title}</label>
      </td>
      <td
        colSpan="3"
        style={{
          backgroundColor: '#FFFFFF',
          textAlign: 'left',
          width: '25%',
        }}
      >
        {!value ? (
          <span style={{ fontSize: '17px', color: '#ff0000' }}>
            {intl.formatMessage({ id: 'unregisteredValue' })}
          </span>
        ) : (
          <span style={{ fontSize: '17px' }}>{value}</span>
        )}
      </td>
    </>
  );
};

const TableRow2575 = ({ title, value }) => {
  const intl = useIntl();

  return (
    <>
      <td
        colSpan="3"
        style={{
          backgroundColor: '#e6e6e6',
          textAlign: 'left',
          width: '25%',
        }}
      >
        <label style={{ fontSize: '17px' }}>{title}</label>
      </td>
      <td
        colSpan="9"
        style={{
          backgroundColor: '#FFFFFF',
          textAlign: 'center',
          width: '12,5%',
        }}
      >
        {!value ? (
          <span style={{ fontSize: '17px', color: '#ff0000' }}>
            {intl.formatMessage({ id: 'unregisteredValue' })}
          </span>
        ) : (
          <span style={{ fontSize: '17px' }}>{value}</span>
        )}
      </td>
    </>
  );
};

TableRow50.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
TableRow2575.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

TableRow50.defaultProps = {
  value: null,
};

TableRow2575.defaultProps = {
  value: null,
};

export { TableRow50, TableRow2575 };
